// extracted by css-extract-rspack-plugin
export default {"MPPaginationWrapper":"MPPaginationWrapper-oMquRn","mpPaginationWrapper":"MPPaginationWrapper-oMquRn"};